import { FormEvent, useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, Alert, CircularProgress, Paper } from '@mui/material';
import { useAuthContext } from '../context/AuthContext';

export const LoginPage = () => {
  const { login, status, error } = useAuthContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitError, setSubmitError] = useState<string | null>(null);

  const isLoading = status === 'checking';

  useEffect(() => {
    setSubmitError(error);
  }, [error]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitError(null);
    try {
      await login(email, password);
    } catch (err) {
      console.error('Falha no login', err);
    }
  };

  if (status === 'bypassed') {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#05070b',
        padding: 2,
      }}
    >
      <Paper
        component="form"
        onSubmit={handleSubmit}
        elevation={8}
        sx={{
          width: '100%',
          maxWidth: 420,
          padding: 4,
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          backgroundColor: '#0f172a',
          color: '#e2e8f0',
        }}
      >
        <Box>
          <Typography variant="h4" component="h1" fontWeight={700} color="#fff">
            RammeTec Monitor
          </Typography>
          <Typography variant="body2" color="#94a3b8">
            Faça login com seu e-mail corporativo para continuar.
          </Typography>
        </Box>

        {submitError && (
          <Alert severity="error" onClose={() => setSubmitError(null)}>
            {submitError}
          </Alert>
        )}

        <TextField
          label="E-mail"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
          InputLabelProps={{ style: { color: '#94a3b8' } }}
          InputProps={{ style: { color: '#fff' } }}
        />
        <TextField
          label="Senha"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
          InputLabelProps={{ style: { color: '#94a3b8' } }}
          InputProps={{ style: { color: '#fff' } }}
        />

        <Button
          type="submit"
          variant="contained"
          disabled={isLoading}
          sx={{ backgroundColor: '#1f6feb', fontWeight: 600 }}
          endIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : undefined}
        >
          {isLoading ? 'Entrando...' : 'Entrar'}
        </Button>
      </Paper>
    </Box>
  );
};

